import type { District } from '../plot.ts'
import { decals, look, maze, woodsy } from '../kit.ts'

/** Pond Park: ducks, a gazebo, picnic blankets and a hedge maze with something golden in the middle. */
export const park: District = {
  id: 'park',
  name: 'Pond Park',
  ground: 'grass',
  ambience: ['fireflies'],
  build(p) {
    p.zone(0, 13, 36, 2, 'gravel'); p.zone(26, 0, 2, 32, 'gravel')
    const m = maze(3, 16, 7, 1729)
    p.prop(...m.hedges, { kind: 'statue', x: m.center[0], y: m.center[1], color: '#ffd166' })
    p.keep(2, 15, 17, 17)
    p.prop(
      { kind: 'pond', x: 17, y: 3, w: 8, d: 5 },
      { kind: 'stone', x: 18, y: 9 }, { kind: 'stone', x: 19, y: 10 }, { kind: 'stone', x: 20, y: 9 },
      { kind: 'gazebo', x: 29, y: 3 },
      { kind: 'picnic', x: 6, y: 4, color: '#ff8fab' }, { kind: 'picnic', x: 30, y: 20, color: '#6ec6ff' },
      { kind: 'bench', x: 14, y: 10, face: 1 }, { kind: 'bench', x: 21, y: 11, face: -1 },
      { kind: 'flowers', x: 15, y: 2, color: '#ffd166' }, { kind: 'flowers', x: 25, y: 9, color: '#ff8fab' }, { kind: 'flowers', x: 2, y: 9, color: '#b69cff' },
      { kind: 'signpost', x: 4, y: 12, text: 'Hedge Maze' },
    )
    p.tram(30, 27)
    p.place({ id: 'park', name: 'Pond Park', blurb: 'Ducks, a gazebo and the good kind of quiet.', x: 21, y: 12, accent: '#5fbf9f', r: 10 })
    p.place({ id: 'maze', name: 'Hedge Maze', blurb: 'Something golden waits in the middle.', x: m.entrance[0], y: m.entrance[1] - 1, accent: '#3f9d6a', r: 3 })
    p.place({ id: 'maze-heart', name: 'Heart of the Maze', blurb: 'You found it. The golden blob approves.', x: m.center[0] + 1, y: m.center[1], accent: '#ffd166', r: 1.5 })
    p.scatter({ density: 0.13, pick: woodsy([['tree', 6], ['bush', 2], ['flowers', 1]]) })
    p.critter({ kind: 'duck', loop: [[17.8, 3.8], [23.6, 4.1], [23.4, 6.6], [18.4, 6.4]], speed: 0.35 })
    p.critter({ kind: 'duck', loop: [[22.6, 6.2], [19.4, 5.4], [21.2, 3.9]], speed: 0.28 })
    p.critter({ kind: 'butterfly', loop: [[28, 18], [34, 22], [31, 29], [22, 25]], speed: 0.55 })
    p.npc({
      id: 'npc-moss', name: 'Old Moss', role: 'Duck friend', look: look('oldmoss', 5, 8, 1, 'cowboy'), speed: 0.8,
      stops: [
        { x: 14, y: 10, wait: 40, emote: 'happy', say: -1 },
        { x: 16, y: 9, wait: 10, say: -1 },
        { x: 15, y: 10, wait: 30, nap: true },
      ],
      lines: ['The ducks know me.', 'Quack yourself.', 'Nobody has ever finished that maze. Well. Nobody I know.', 'Back in my day, the pond was a puddle.'],
    })

    // ─── Detail ───
    p.scatter(decals(['clover', 'leaves', 'clover'], 0.08, ['grass']))
    p.prop(
      { kind: 'birdbath', x: 12, y: 4 }, { kind: 'reeds', x: 16, y: 4 }, { kind: 'reeds', x: 25, y: 6 }, { kind: 'reeds', x: 16, y: 7 },
      { kind: 'cart', x: 23, y: 11, color: '#7ee0c3', text: 'Ice cream' }, { kind: 'bench', x: 31, y: 9, face: -1 }, { kind: 'bin', x: 28, y: 12 },
      { kind: 'festoon', x: 28, y: 6, w: 4, d: 1 },
    )
    p.npc({
      id: 'npc-jo', name: 'Jo', role: 'Jogger', look: look('joggerjo', 3, 8, 4, 'headphones'), speed: 2.8,
      stops: [{ x: 1, y: 14, wait: 2 }, { x: 34, y: 14, wait: 3, say: -1 }, { x: 27, y: 30, wait: 2 }, { x: 27, y: 1, wait: 3 }],
      lines: ['…huff… morning!', 'Lap twelve!', 'Can’t stop, personal best!'],
    })
  },
}
